import { BG_COLORS, FONT_SIZES, TEXT_COLORS } from '../globalTheme';
import { COLOR_TYPE, SIZE } from '../globalTypes';
import { Theme } from './theme';

export const BADGE_SPACING: Record<SIZE, string> = {
	xs: '0.25rem',
	sm: '4px 8px 4px 8px ',
	md: '4px 10px 4px 10px ',
	lg: '1rem',
	xl: '1.25rem',
	xxl: '1.5rem'
};

export function getBadgeStyles(theme: Theme) {
	return {
		badge_css: (size: SIZE) => ({
			fontWeight: theme.badge.fontWeight,
			borderRadius: 999,
			textAlign: 'center' as const,
			display: 'flex',
			width: 'fit-content',
			alignItems: 'center',
			fontSize: FONT_SIZES[size],
			padding: BADGE_SPACING[size]
		}),
		badgeIcon_css: {
			marginRight: '0.5rem',
			marginLeft: '0.5rem'
		},
		badgeText_css: {
			display: 'inline'
		},
		badgeBackground_css: (type: COLOR_TYPE) => ({
			backgroundColor: BG_COLORS[type] || BG_COLORS.primary
		}),
		badgeTextColor_css: (type: COLOR_TYPE) => ({
			color: TEXT_COLORS[type] || TEXT_COLORS.primary
		})
	};
}
